export const apiAddress =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3000"
    : "https://api.stadiumsupervisor.com.au";

console.log(`API: ${apiAddress}`);
